<template>
  <div class="auth-page">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">{{ $t('身份认证') }}</div>
    </div>
    <!-- 顶部标题 -->

    <!-- 用户信息卡片 -->
    <div class="user-card" v-if="Object.keys(user).length > 0">
      <div class="avatar-box">
        <!-- 小龙虾头像，这里用文字替代，可替换图片 -->
        <div class="avatar">
          <img src="@/assets/images/mine.png" alt="">
        </div>
      </div>
      <div class="user-info">
        <div class="account-num">{{ user.mobile }}</div>
        <div class="status-text" v-if="r_status === 3">
          <i class="iconfont icon-kefujingli-"></i>
          <span>{{ $t('未认证') }}</span> 
        </div>
        <div class="status-text" v-if="r_status === 1">
          <i class="iconfont icon-kefujingli-" style="color: #2ece49;"></i>
          <span style="color: #2ece49;">{{ $t('已认证') }}</span>
        </div>
      </div>
    </div>

    <!-- 基础认证区域（区分两种状态） -->
    <div class="auth-basic">
      <h2 class="basic-title">{{ $t('基础身份认证') }}</h2>
      <p class="basic-desc">{{ $t('帐户更加安全') }}</p>

      <!-- 状态分支：未认证 / 审核中 -->
      <div v-if="r_status === 3" class="unauth-area">
        <button class="go-auth-btn" @click="handleGoAuth">{{ $t('去认证') }}</button>
        <div class="encrypt-tip">
          <i class="iconfont icon-anquanyinsi"></i> {{ $t('您的资讯在我们的安全服务器上加密') }}
        </div>
      </div>

      <div v-else-if="r_status === 1" class="pending-area">
        <div class="clock-icon"><i class="iconfont icon-duigou"></i></div>
        <div class="pending-text" style="color: #2ece49;">{{ $t('已认证') }}</div>
        <!-- <p class="pending-desc">{{ $t('24小时内被审核') }}</p> -->
      </div>
      <div v-else-if="r_status === 0" class="pending-area">
        <div class="clock-icon"><i class="iconfont icon-duigou"></i></div>
        <div class="pending-text" style="color: #2ece49;">{{ $t('审核中') }}</div>
        <p class="pending-desc">{{ $t('24小时内被审核') }}</p>
      </div>
      <div v-else-if="r_status === 2" class="pending-area">
        <div class="clock-icon" style="display: flex;align-items: center;justify-content: center;">
          <div style="width: 42px;height: 42px;border-radius: 50%;color: red;border:2px solid red;display: flex;align-items: center;justify-content: center;">
            <i class="iconfont icon-guanbi1" style="color: red;font-size: 30px;"></i>
          </div>
        </div>
        <div class="pending-text" style="color: red;">{{ $t('审核拒绝') }}</div>
        <p class="pending-desc" v-if="rejection_reason !== ''" style="color: red;">{{ rejection_reason }}</p>
        <button class="go-auth-btn" @click="handleGoAuth">{{ $t('去认证') }}</button>
      </div>
    </div>

    <!-- 认证权益对比区域 -->
    <div class="benefit-wrap">
      <h3 class="benefit-title">{{ $t('享有以下权益') }}</h3>
      <!-- 表头 -->
      <div class="benefit-header">
        <div class="header-empty"></div>
        <div class="header-col">{{ $t('未认证') }} <span class="current-tag" v-if="r_status === 3">{{ $t('当前') }}</span></div>
        <div class="header-col">{{ $t('认证后') }} <span class="current-tag" v-if="r_status === 1">{{ $t('当前') }}</span></div>
      </div>
      <!-- 权益列表 -->
      <div class="benefit-list">
        <div class="benefit-row">
          <div class="row-label">{{ $t('每日认购额度') }}</div>
          <div class="row-cell">≦{{total_subscription_limit}}USD</div>
          <div class="row-cell">{{ $t('无限制') }}</div>
        </div>
        <div class="benefit-row">
          <div class="row-label">{{ $t('每日认购项目') }}</div>
          <div class="row-cell">{{ $t('个', { num: remaining_subscription_limit }) }}</div>
          <div class="row-cell">{{ $t('无限制') }}</div>
        </div>
        <div class="benefit-row">
          <div class="row-label">{{ $t('查阅影视项目') }}</div>
          <div class="row-cell"><i class="iconfont icon-guanbi"></i></div>
          <div class="row-cell"><i class="iconfont icon-duihao"></i></div>
        </div>
        <div class="benefit-row">
          <div class="row-label">{{ $t('认购影视项目') }}</div>
          <div class="row-cell"><i class="iconfont icon-guanbi"></i></div>
          <div class="row-cell"><i class="iconfont icon-duihao"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';

export default {
  name: 'IdentityAuth',
  data() {
    return {
      user: {},
      r_status: -1,
      remaining_subscription_limit:0,
      total_subscription_limit:0,
      rejection_reason:''
    }
  },
  created() {
    this.$parent.footer('idCard', false);
    this.start()
    Fetch('/user/real_name_status').then((r) => {
      // console.log(r,'rrr')
      if (r.code === 1) {
        this.r_status =  r.data.r_status
        if(this.r_status === 2) {
          this.rejection_reason = r.data.rejection_reason
        }
      } else {
        this.$toast({
          background: "#07c160",
          message: this.$t(r.info)
        });
      }
    });
  },
  methods: {
    start() {
      Fetch('/user/info').then((r) => {
        this.user = r.data;
      });
      Fetch('/index/webconfig').then((r) => {
          this.remaining_subscription_limit = r.data.remaining_subscription_limit
          this.total_subscription_limit = r.data.total_subscription_limit
      });
    },
    // 点击去认证按钮
    handleGoAuth() {
      // console.log('跳转认证表单页');
      this.$router.push('/idCardDetail')
      // 模拟提交后切换为审核中状态
      // this.authStatus = 'pending'
    }
  }
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: system-ui, -apple-system, sans-serif;
}

.auth-page {
  background: #fff;
  min-height: 100vh;
  padding-bottom: 120px;
}

/* 顶部标题 */
.page-title {
  font-size: 26px;
  font-weight: bold;
  padding: 30px 20px 15px;
}

/* 用户卡片 */
.user-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 20px 24px;
}

.avatar-box .avatar {
  width: 75px;
  height: 75px;
  border-radius: 12px;
  background: #f5f5f5;
  box-shadow: solid 1px #E5E6E7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.user-info .account-num {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 15px;
}

.user-info .status-text {
  color: #999;
  font-size: 14px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 基础认证模块 浅绿色背景 */
.auth-basic {
  margin: 0 16px 40px;
  background: #e9f7ef;
  border-radius: 14px;
  padding: 35px 20px;
  text-align: center;
}

.basic-title {
  font-size: 22px;
  font-weight: bold;
  word-break: keep-all;
  margin-bottom: 15px;
}

.basic-desc {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}

/* 未认证区域 */
.go-auth-btn {
  width: 100%;
  background: #000;
  color: #fff;
  font-size: 16px;
  padding: 14px 0;
  border-radius: 99px;
  border: none;
  cursor: pointer;
  margin-bottom: 20px;
}

.encrypt-tip {
  color: #555;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* 审核中区域 */
.pending-area .clock-icon {
  font-size: 48px;
  margin-bottom: 10px;

  .icon-duigou {
    font-size: 42px;
    color: #2ece49;
  }
}

.pending-text {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

.pending-desc {
  color: #666;
  font-size: 16px;
  margin-top: 15px;
}

/* 权益模块 */
.benefit-wrap {
  padding: 0 20px;
}

.benefit-title {
  font-size: 15px;
  margin-bottom: 25px;
}

/* 权益表头 */
.benefit-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  text-align: center;
  font-size: 12px;
  color: #888;
  margin-bottom: 15px;
  align-items: center;
}

.current-tag {
  background: #000;
  color: #fff;
  display: block;
  padding: 4px 8px;
  border-radius: 6px 0px 6px 0px;
  margin-left: 6px;
}

/* 权益行 */
.benefit-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  text-align: center;
  font-size: 19px;
  padding: 14px 0;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.row-label {
  text-align: left !important;
  color: #222;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.row-cell {
  color: #333;
  font-size: 12px;
}

/* KAI底部logo */
.kai-logo {
  font-size: 60px;
  font-weight: 900;
  padding: 40px 20px;
  letter-spacing: 6px;
}

/* 底部Tab栏 */
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background: #fff;
  border-top: 1px solid #eee;
  display: flex;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
}

.tab-icon {
  font-size: 24px;
}

.header-col {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 12px;
  text-align: center;
  padding: 0 2px;
  word-break:  keep-all;
}

.red_top_bg {
  width: 100%;
  height: 50px;
  position: sticky;
  top: 0px;
  z-index: 999;
  background: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F8F8FA;
  padding: 0 10px;

  .back_left {
    width: 20px;
    height: 20px;
  }
}
.big_tit {
  white-space: nowrap;
}
.icon-duihao {
  color: #2ece49;
}

.icon-guanbi {
  color: #ce2e2e;
}
</style>